import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import CategoryIcon from "@/Components/website/common/Icons/synopsis/CategoryIcon";
import ProductIcon from "@/Components/website/common/Icons/synopsis/ProductIcon";
import IndicationIcon from "@/Components/website/common/Icons/synopsis/IndicationIcon";
import MechanismIcon from "@/Components/website/common/Icons/synopsis/MechanismIcon";
// import EfficacyIcon from "@/Components/website/common/Icons/synopsis/EfficacyIcon";
import SafetyIcon from "@/Components/website/common/Icons/synopsis/SafetyIcon";
import DosingIcon from "@/Components/website/common/Icons/synopsis/DosingIcon";
import PatientIcon from "@/Components/website/common/Icons/synopsis/PatientIcon";
import CostIcon from "@/Components/website/common/Icons/synopsis/CostIcon";
import ReviewsIcon from "@/Components/website/common/Icons/synopsis/ReviewsIcon";
import RatingIcon from "@/Components/website/common/Icons/synopsis/RatingIcon";
const SkeletonLoader = t0 => {
  const $ = _c(11);
  const {
    label
  } = t0;
  switch (label) {
    case "Product":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-1/3 mb-2" /></div>;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    case "Category":
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-1/6 mb-2" /></div>;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "Indication":
      {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-1/4 mb-2" /><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-1/4 mb-2" /></div>;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case "Mechanism":
      {
        let t1;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-3/5 mb-2" /></div>;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "Efficacy":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-3/4 mb-2" /></div>;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "Safety":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-4/5 mb-2" /></div>;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "Dosing":
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-[90%] mb-2" /><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-[20%] mb-2" /></div>;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case "Patient":
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-[60%] mb-2" /></div>;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "Cost":
      {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-4/5 mb-2" /></div>;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case "Reviews":
      {
        let t1;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-2/3 mb-2" /></div>;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    default:
      {
        let t1;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <div className="flex-1 shrink self-stretch basis-0 animate-pulse"><div className="h-4 bg-gray-200 rounded-full dark:bg-gray-200 w-full mb-2" /></div>;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        return t1;
      }
  }
};
const InfoRow = t0 => {
  const $ = _c(44);
  const {
    icon,
    label,
    value,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [showAllIndications, setShowAllIndications] = React.useState(false);
  let t2;
  if ($[0] !== isExpanded) {
    t2 = () => {
      setIsExpanded(!isExpanded);
    };
    $[0] = isExpanded;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggleExpand = t2;
  if (label === "Indication") {
    let t3;
    if ($[2] !== value) {
      t3 = Array.isArray(value) ? value : [];
      $[2] = value;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    const items = t3;
    let t4;
    if ($[4] !== items || $[5] !== showAllIndications) {
      t4 = showAllIndications ? items : items.slice(0, 5);
      $[4] = items;
      $[5] = showAllIndications;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const visibleItems = t4;
    const hiddenCount = items.length - visibleItems.length;
    let t5;
    if ($[7] !== icon) {
      t5 = <div className="shrink-0 w-5 sm:w-6 aspect-square">{icon}</div>;
      $[7] = icon;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="font-medium text-black w-auto sm:w-[88px] shrink-0">Indication:</div>;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== hiddenCount || $[11] !== items.length || $[12] !== label || $[13] !== showAllIndications || $[14] !== visibleItems) {
      t7 = <div className="flex flex-col sm:flex-row grow shrink gap-1 sm:gap-4 items-start min-w-0">{t6}{items.length > 0 ? <div className="flex-1 leading-6 sm:leading-7 text-neutral-600"><ul className={items.length > 1 ? "list-disc ml-4 sm:ml-0" : ""}>{visibleItems.map(_temp)}</ul>{items.length > 5 && <button type="button" onClick={() => setShowAllIndications(_temp2)} className="mt-1 text-primary-primaryBlue hover:underline font-medium text-xs sm:text-sm" aria-label={showAllIndications ? "Show fewer indications" : `Show ${hiddenCount} more indications`}>{showAllIndications ? "Show less" : `+${items.length - 5} more`}</button>}</div> : <SkeletonLoader label={label} />}</div>;
      $[10] = hiddenCount;
      $[11] = items.length;
      $[12] = label;
      $[13] = showAllIndications;
      $[14] = visibleItems;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t5 || $[17] !== t7) {
      t8 = <div className="flex gap-2 max-md:gap-4 items-start mt-3 sm:mt-4 w-full text-xs sm:text-sm min-h-[24px]">{t5}{t7}</div>;
      $[16] = t5;
      $[17] = t7;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    return t8;
  }
  if (label === "Reviews") {
    let t3;
    if ($[19] !== icon) {
      t3 = <div className="shrink-0 w-5 sm:w-6 aspect-square">{icon}</div>;
      $[19] = icon;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    let t4;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="self-stretch font-medium text-black w-auto sm:w-[88px] shrink-0">Reviews:</div>;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    let t5;
    if ($[22] !== label || $[23] !== value) {
      t5 = <div className="flex flex-col sm:flex-row grow shrink gap-1 sm:gap-4 items-start self-stretch min-h-[21px] min-w-0">{t4}{value !== undefined && value !== null ? <div className="flex flex-wrap flex-1 shrink gap-1 items-start self-stretch basis-0 min-w-0"><div className="flex gap-1 items-center self-stretch text-black whitespace-nowrap">{(() => {
              const numValue = Number(value);
              const isNoRating = value == "NaN" || value == null || value === "" || numValue === 0 || value === "0";
              if (isNoRating) {
                return <div className="self-stretch text-neutral-600">No reviews yet</div>;
              }
              const rating = Math.min(Math.max(numValue, 0), 5);
              const fullStars = Math.floor(rating);
              const hasHalfStar = rating % 1 >= 0.5 && rating < 5;
              const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
              return <><div className="self-stretch">{value}</div><div className="flex items-center gap-0.5">{Array.from({
                    length: fullStars
                  }).map(_temp3)}{hasHalfStar && <div className="mt-[2px] object-contain shrink-0 w-3 sm:w-4 aspect-square relative"><div className="absolute inset-0"><RatingIcon color="#E5E7EB" /></div><div className="absolute inset-0 overflow-hidden" style={{
                      width: "50%"
                    }}><RatingIcon color="#1E5EFF" /></div></div>}{Array.from({
                    length: emptyStars
                  }).map(_temp4)}</div></>;
            })()}<span className="text-blue-600 cursor-pointer font-medium ml-2 text-xs sm:text-sm" onClick={_temp6}>see more</span></div></div> : <SkeletonLoader label={label} />}</div>;
      $[22] = label;
      $[23] = value;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    let t6;
    if ($[25] !== t3 || $[26] !== t5) {
      t6 = <div className="flex gap-2 max-md:gap-4 items-start mt-3 sm:mt-4 w-full text-xs sm:text-sm min-h-[24px]">{t3}{t5}</div>;
      $[25] = t3;
      $[26] = t5;
      $[27] = t6;
    } else {
      t6 = $[27];
    }
    return t6;
  }
  const t3 = `flex gap-2 max-md:gap-4 items-start w-full text-xs sm:text-sm min-h-[24px] ${className}`;
  let t4;
  if ($[28] !== icon) {
    t4 = <div className="object-contain shrink-0 w-5 sm:w-6 aspect-square">{icon}</div>;
    $[28] = icon;
    $[29] = t4;
  } else {
    t4 = $[29];
  }
  let t5;
  if ($[30] !== label) {
    t5 = <div className="self-stretch font-medium text-black w-auto sm:w-[88px] shrink-0">{label}:</div>;
    $[30] = label;
    $[31] = t5;
  } else {
    t5 = $[31];
  }
  let t6;
  if ($[32] !== isExpanded || $[33] !== label || $[34] !== toggleExpand || $[35] !== value) {
    t6 = value ? <div className="flex-1 shrink self-stretch basis-0 text-neutral-600">{typeof value === "string" && value.length > 200 ? <>{isExpanded ? value : `${value.substring(0, 200)}...`}<span className="text-black underline cursor-pointer font-medium" onClick={toggleExpand}>{isExpanded ? " Read Less" : " Read More"}</span></> : value}</div> : <SkeletonLoader label={label} />;
    $[32] = isExpanded;
    $[33] = label;
    $[34] = toggleExpand;
    $[35] = value;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  let t7;
  if ($[37] !== t5 || $[38] !== t6) {
    t7 = <div className="flex flex-col sm:flex-row grow shrink gap-1 sm:gap-4 items-start self-stretch my-auto min-h-[21px] min-w-0">{t5}{t6}</div>;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  let t8;
  if ($[40] !== t3 || $[41] !== t4 || $[42] !== t7) {
    t8 = <div className={t3}>{t4}{t7}</div>;
    $[40] = t3;
    $[41] = t4;
    $[42] = t7;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  return t8;
};
export const SynopsisData = t0 => {
  const $ = _c(18);
  const {
    synopsisData,
    reviews,
    onSkeletonLoad
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      label: "Product",
      field: "product",
      icon: <ProductIcon />
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      label: "Category",
      field: "category",
      icon: <CategoryIcon />
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      label: "Indication",
      field: "indication",
      icon: <IndicationIcon />
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      label: "Mechanism",
      field: "mechanism",
      icon: <MechanismIcon />
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      label: "Safety",
      field: "safety",
      icon: <SafetyIcon />
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      label: "Dosing",
      field: "dosing",
      icon: <DosingIcon />
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      label: "Patient",
      field: "patient",
      icon: <PatientIcon />
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [t1, t2, t3, t4, t5, t6, t7, {
      label: "Reviews",
      field: "reviews",
      icon: <ReviewsIcon />,
      ratingIcon: <RatingIcon />
    }];
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const synopsisContent = t8;
  let t10;
  let t9;
  if ($[8] !== onSkeletonLoad || $[9] !== reviews || $[10] !== synopsisData) {
    t9 = () => {
      if (synopsisData && onSkeletonLoad) {
        const hasAnySkeleton = synopsisContent.some(content => {
          if (content.field !== "reviews") {
            return !synopsisData[content.field];
          } else {
            return !reviews;
          }
        });
        onSkeletonLoad(hasAnySkeleton);
      }
    };
    t10 = [synopsisData, reviews, onSkeletonLoad];
    $[8] = onSkeletonLoad;
    $[9] = reviews;
    $[10] = synopsisData;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  React.useEffect(t9, t10);
  let t11;
  if ($[13] !== reviews || $[14] !== synopsisData) {
    t11 = synopsisData && synopsisContent.map((content_0, index) => {
      if (content_0.field != "reviews") {
        return <InfoRow key={content_0.field} icon={content_0.icon} label={content_0.label} value={synopsisData[content_0.field]} className="mt-3 sm:mt-4" />;
      } else {
        return <InfoRow key={content_0.field} icon={content_0.icon} label={content_0.label} value={reviews} className="mt-3 sm:mt-4" />;
      }
    });
    $[13] = reviews;
    $[14] = synopsisData;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <>{t11}</>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};
function _temp(indication, index) {
  return <li key={index}>{indication.charAt(0).toUpperCase() + indication.slice(1)}</li>;
}
function _temp2(v) {
  return !v;
}
function _temp3(_, i) {
  return <div key={`full-${i}`} className="mt-[2px] object-contain shrink-0 w-3 sm:w-4 aspect-square"><RatingIcon color="#1E5EFF" /></div>;
}
function _temp4(__0, i_0) {
  return <div key={`empty-${i_0}`} className="mt-[2px] object-contain shrink-0 w-3 sm:w-4 aspect-square"><RatingIcon color="#E5E7EB" /></div>;
}
function _temp5() {
  const reviewsSection = document.getElementById("reviews");
  if (reviewsSection) {
    reviewsSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest"
    });
  }
}
function _temp6() {
  setTimeout(_temp5, 300);
}